// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file internal.proto (package river, syntax proto3)
/* eslint-disable */
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_protocol } from "./protocol_pb";
/**
 * Describes the file internal.proto.
 */
export const file_internal = /*@__PURE__*/ fileDesc("Cg5pbnRlcm5hbC5wcm90bxIFcml2ZXIicwoOUGVyc2lzdGVkRXZlbnQSIQoFZXZlbnQYASABKAsyEi5yaXZlci5TdHJlYW1FdmVudBIMCgRoYXNoGAIgASgMEhcKD2NyZWF0b3JfdXNlcl9pZBgEIAEoCRIRCglzaWduYXR1cmUYBSABKAxKBAgDEAQicQoSUGVyc2lzdGVkTWluaWJsb2NrEgwKBGhhc2gYASABKAwSJgoGaGVhZGVyGAIgASgLMhYucml2ZXIuTWluaWJsb2NrSGVhZGVyEiUKBmV2ZW50cxgDIAMoCzIVLnJpdmVyLlBlcnNpc3RlZEV2ZW50Iq8BChVQZXJzaXN0ZWRTeW5jZWRTdHJlYW0SJgoLc3luY19jb29raWUYASABKAsyES5yaXZlci5TeW5jQ29va2llEiMKG2xhc3Rfc25hcHNob3RfbWluaWJsb2NrX251bRgCIAEoBBIaChJsYXN0X21pbmlibG9ja19udW0YAyABKAQSLQoObWluaXBvb2xFdmVudHMYBCADKAsyFS5yaXZlci5QZXJzaXN0ZWRFdmVudGIGcHJvdG8z", [file_protocol]);
/**
 * Describes the message river.PersistedEvent.
 * Use `create(PersistedEventSchema)` to create a new message.
 */
export const PersistedEventSchema = /*@__PURE__*/ messageDesc(file_internal, 0);
/**
 * Describes the message river.PersistedMiniblock.
 * Use `create(PersistedMiniblockSchema)` to create a new message.
 */
export const PersistedMiniblockSchema = /*@__PURE__*/ messageDesc(file_internal, 1);
/**
 * Describes the message river.PersistedSyncedStream.
 * Use `create(PersistedSyncedStreamSchema)` to create a new message.
 */
export const PersistedSyncedStreamSchema = /*@__PURE__*/ messageDesc(file_internal, 2);
//# sourceMappingURL=internal_pb.js.map